import React, { Component } from 'react';
import moment from 'moment';
import flightService from '../../services/flight';
import statusService from '../../services/status';
import config from '../../config';
import queryString from 'query-string';
import './index.css';
import DatePicker from 'react-datepicker';
import languageService from '../../services/language';
import Clocks from '../../components/clocks';
import Destinations from '../../components/destinations';
import 'react-datepicker/dist/react-datepicker.css';

const MAX_LEN_FROMTO = 22;
const MAX_LEN_COMPANY = 10;
const MAX_LEN_STATUS = 12;
const MAX_LEN_CODE = 7;

class ExampleCustomInput extends React.Component {
  render () {
    const text = {
      'Ro': 'Alege o dată',
      'En': 'Pick a date'
    }[languageService.language] || 'Alege o dată';

    return (
      <button className="btn btn-info" onClick={this.props.onClick}>
        {text} <i className="fa fa-calendar" />
      </button>
    )
  }
}

class FlightsTable extends Component {
  state = {
    flights: null,
    statuses: null,
    arrivals: "true",
    departures: "false",
		flightsDate: moment(),
    showDestinations: false
  };

	constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    this.setState({
      flightsDate: date,
      showDestinations: false
    }, () => {
      this.updateFlights();
    });
  }

  showArrivals() {
    this.setState({
      arrivals: "true",
      showDestinations: false,
      departures: null
    });
  }

  showDepartures() {
    this.setState({
      departures: "true",
      showDestinations: false,
      arrivals: null
    });
  }

  componentDidMount() {
    const parsed = queryString.parse(this.props.queryParams);

    if (parsed && Object.keys(parsed).length > 0) {
      this.setState({
        departures: parsed.departures,
        arrivals: parsed.arrivals
      });
    }

    statusService.data()
    .then(this.saveStatusesInState.bind(this))
    .then(this.updateFlights.bind(this))
    .then(() => {
      setInterval(this.updateFlights.bind(this), config.refreshInterval);
    })
    .catch((e) => {
      console.error(e);
    })
  }

  saveStatusesInState(statuses) {
    this.setState({
      statuses: statuses
    });
  }

  updateFlights() {
    let date = this.state.flightsDate;

    if (this.props.tv) {
      date = moment();
    }

		const dayStart = moment(date).startOf('day');
		let dayEnd = moment(date).endOf('day');

    if (this.props.tv) {
      dayEnd = moment(date.add(1, 'day')).endOf('day');
    }

    let query = {};

    query.date = {
  		'>=': dayStart,
  		'<=': dayEnd
    };

    return flightService.dataWithQuery(query)
    .then(this.updateFlightsInSate.bind(this))
  }

  updateFlightsInSate(flights) {
		if (!flights || (flights && flights.length < 1)) {
			return null;
		}

    const lastUpdatedAt = flights.sort((a, b) => {
      const updA = moment(a.updatedAt).valueOf();
      const updB = moment(b.updatedAt).valueOf();

      if (updA < updB) {
        return 1;
      } else {
        return -1;
      }
    })[0];

    flights = flights.map(flight => {
      flight.status = flightService.dynamicStatusForFlight(flight);
      flight.statusName = this.state.statuses.filter(status => status.code === flight.status)[0].nameEn;
      flight.statusCode = flight.status;

      return flight;
    });

    this.setState({
      flights: flights,
      lastUpdatedAt: moment(lastUpdatedAt.updatedAt).format('HH:mm, DD.MM.YYYY')
    });
  }

  renderSolariLetter(letter, additionalClassName) {
    let className = (letter !== ' ') ? 'solari-letter' : 'solari-letter blank';

    if (additionalClassName) {
      className = className + " " + additionalClassName;
    }

    letter = (letter !== ' ') ? letter : 'X';
    const style = {
      color: this.props.textColor,
      backgroundColor: this.props.textBackgroundColor,
      fontFamily: this.props.textFont
    };

    return (
      <span className={className} style={style}><span className="solari-letter-letter">{ letter }</span></span>
    );
  }

  getFormattedFieldFromFlight(field, flight) {
    return field.format ? field.format(flight[field.property]) : flight[field.property];
  }

  renderFlightsForTV(fields) {
    let flights = this.state.flights;

    if (flights) {
      flights = flights.map(flight => {
        flights = flights.map(flight => {
          flight.status = flightService.dynamicStatusForFlight(flight);

          return flight;
        });

        flight.statusName = this.state.statuses.filter(status => status.code === flight.status)[0].nameEn;
        flight.statusCode = flight.status;

        return flight;
      });

      if (this.state.departures === 'true') {
        flights = flights.filter(fl => fl.from === 'IASI')
        flights = this.sortFlightsByField(flights, 'departAt');
      } else if (this.state.arrivals === 'true') {
        flights = flights.filter(fl => fl.to === 'IASI')
        flights = this.sortFlightsByField(flights, 'arriveAt');
      }

      return flights.map((flight, index) => {
        let letters = [];

        fields.forEach((field, index) => {
          let prop = this.getFormattedFieldFromFlight(field, flight);
          let len = prop.length;

          this.state.flights.forEach(fl => {
            if (this.getFormattedFieldFromFlight(field, fl).length > prop.length) {
              len = this.getFormattedFieldFromFlight(field, fl).length;
            }
          });

          if (typeof prop === 'string') {
            prop = prop.split('').map(letter => {
              let className = '';

              if (field.property === 'statusName') {
                className = 'solari-status';
              }

              return this.renderSolariLetter(letter, className);
            });
          }

          letters.push(prop);

          if (field.property === 'terminal') {
            len = 3;
          }

          if (field.property === 'arriveAt') {
            len = 6;
          }

          if (field.property === 'departAt') {
            len = 6;
          }

          if (field.property === 'to' || field.property === 'from') {
            len = MAX_LEN_FROMTO;
          }

          if (field.property === 'company') {
            len = MAX_LEN_COMPANY;
          }

          if (field.property === 'statusName') {
            len = MAX_LEN_STATUS;

            if (field.extraProperty === 'delay' && flight[field.extraProperty]) {
              letters.push(this.renderSolariLetter(' '));
              for (let i = 0; i < flight[field.extraProperty].toString().length; i++) {
                letters.push(this.renderSolariLetter(flight[field.extraProperty].toString()[i]));
              }
              letters.push(this.renderSolariLetter('m'));
              len -= flight[field.extraProperty].toString().length + 2;
            }
          }

          if (field.property === 'code') {
            len = MAX_LEN_CODE;
          }

          for (let i = 0; i <= len - prop.length; i++) {
            letters.push(this.renderSolariLetter(' '));
          }

          if (index === fields.length - 1) {
            letters.push(this.renderSolariLetter(' '));

            if (flight.statusCode === 0) {
              letters.push(this.renderSolariLetter('○'));
            } else {
              letters.push(this.renderSolariLetter('●'));
            }

            len = 20;

            for (let i = 0; i <= 30; i++) {
              letters.push(this.renderSolariLetter(' '));
            }
          }
        });

        let trStyle = {};
        let trClassName = '';

        if (flight.statusCode === 3) {
          trClassName = 'solari-warning';
        }

        if (flight.statusCode === 4) {
          trClassName = 'solari-danger';
        }

        if (flight.daySeparator) {
          trClassName += ' daySeparator';
        }

        return (
          <tr className={trClassName} style={trStyle} key={`comp-flights-table-flight-${index}`}>
            <td>
              {letters}
            </td>
          </tr>
        );
      });
    } else {
      return null;
    }
  }

	sortFlightsByField(flights, field, shouldPersist) {
    let daySeparator = false;

		return flights.sort((a, b) => {
			const dateA = moment(a[field]);
			const dateB = moment(b[field]);

			if (dateA.isBefore(dateB)) {
				return -1;
			} else if (dateA.isAfter(dateB)) {
				return 1;
			} else {
				return 0;
			}
		})
    .filter(flight => {
      let delay = flight.delay ? (flight.delay * 60000) : 0;
      let buffer = config.flightBuffer;

      const now = moment().valueOf();
      const flightTime = moment(flight[field]).valueOf() + delay;

      return shouldPersist ? true : flightTime + buffer > now;
    })
    .map(flight => {
      let date = null;

      if (daySeparator === false) {
        if (flight.departAt) {
          date = flight.departAt;
        } else if (flight.arriveAt) {
          date = flight.arriveAt;
        }

        if (!moment(date).isSame(moment(), 'day')) {
          flight.daySeparator = true;

          daySeparator = true;
        }
      }

      return flight;
    });
	}

  renderFlights(fields) {
    let flights = this.state.flights;

    if (flights) {
      if (this.state.departures === 'true') {
        flights = flights.filter(fl => fl.from === 'IASI')
        flights = this.sortFlightsByField(flights, 'departAt', true);
      } else if (this.state.arrivals === 'true') {
        flights = flights.filter(fl => fl.to === 'IASI')
        flights = this.sortFlightsByField(flights, 'arriveAt', true);
      }

      return flights.map((flight, index) => {
        const tds = fields.map((field, index) => {
          let prop = field.format ? field.format(flight[field.property]) : flight[field.property];
          let extraProp = field.extraFormat ? field.extraFormat(flight[field.extraProperty]) : flight[field.extraProperty];
          let tableClassName = field.tableClassName || '';
          let link = field.link ? field.link(flight[field.property]) : null;
          let content = <span>{prop} {extraProp}</span>;

          if (link) {
            content = (
              <a href={link} target='_blank'>
                {content}
              </a>
            );
          }

          return (
            <td className={tableClassName} key={`comp-flights-table-flight-${index}-${flight.code}-${flight[field.property]}`}>
              {content}
            </td>
          );
        });

        let trStyle = {};

        if (flight.statusCode === 3) {
          trStyle = {
            backgroundColor: this.props.warningBackgroundColor,
            color: this.props.alertTextColor
          };
        }

        if (flight.statusCode === 4) {
          trStyle = {
            backgroundColor: this.props.alertBackgroundColor,
            color: this.props.alertTextColor
          };
        }

        return (
          <tr style={trStyle} key={`comp-flights-table-flight-${index}`}>
            { tds }
          </tr>
        );
      });
    } else {
      return null;
    }
  }

  constructFields() {
    const departures = this.state.departures;
    const arrivals = this.state.arrivals;
    let fields = [];

    if (departures === "true") {
      fields = fields.concat([
        { name: 'Departure', property: 'to' },
        { name: 'Ora', property: 'departAt', format: (date) => moment(date).format('HH:mm')  }
      ]);
    }

    if (arrivals === "true") {
      fields = fields.concat([
        { name: 'From', property: 'from' },
        { name: 'Ora', property: 'arriveAt', format: (date) => moment(date).format('HH:mm') },
      ]);
    }

    fields = fields.concat([
      { name: 'Numar zbor', property: 'code' },
      { name: 'Companie', property: 'company', format: (company) => company ? company.name : '', link: (company) => company ? company.url: '' },
      { name: 'Status', tableClassName: 'u-f-uppercase', property: 'statusName', extraProperty: 'delay', extraFormat: (delay) => delay ? `${delay}m` : '' }
    ]);

    fields = fields.concat([
      { name: 'Terminal', property: 'terminal' },
    ]);

    return fields;

  }

  renderTableForTv(className, ths, flights, style) {
    let letters = [
      this.state.departures === 'true' ? 'Destination' : 'From',
      'Time  ',
      'Flight',
      'Company',
      'Status',
      'T.'
    ];

    let l;

    l = letters[0].length;

    for (let i = 0; i < MAX_LEN_FROMTO - l; i++) {
      letters[0] = letters[0].concat(' ');
    }

    l = letters[2].length;

    for (let i = 0; i < MAX_LEN_CODE - l; i++) {
      letters[2] = letters[2].concat(' ');
    }

    l = letters[3].length;

    for (let i = 0; i < MAX_LEN_COMPANY - l; i++) {
      letters[3] = letters[3].concat(' ');
    }

    l = letters[4].length;

    for (let i = 0; i < MAX_LEN_STATUS - l; i++) {
      letters[4] = letters[4].concat(' ');
    }

    for (let i = 0; i <= 10; i++) {
      letters = letters.concat(' ');
    }

    letters = letters.join(' ').split('');

    letters = letters.map(this.renderSolariLetter.bind(this));

    let content = null;

    if (this.state.flights) {
      content = (
        <div className="tv">
          <table className={className} style={style}>
            <thead>
              <tr>
                <th>
                  {letters}
                </th>
              </tr>
            </thead>
            <tbody>
              { flights }
            </tbody>
          </table>

          <div className="clearfix"></div>
        </div>
      );
    } else {
      content = (
        <div className="tv--logo">
          <img src={this.props.global.logoUrl} alt="Aeroport Iasi" />
        </div>
      )
    }

    return content;
  }

  renderTable(className, ths, flights, style) {
    return (
      <div className="u-of-x-scroll">
        <table className={`${className} table-striped`} style={style}>
          <thead>
            <tr>
              {ths}
            </tr>
          </thead>
          <tbody>
            {flights}
          </tbody>
        </table>
      </div>
    );
  }

  showDestinations() {
    this.setState({
      arrivals: false,
      departures: false,
      showDestinations: true
    });
  }

  render() {
    let fields = null;
    let flights = null;
    let className = '';
    let style = {};
    let table = null;
    let tableContainerStyle = {};
    let rendered = null;
    let ths = null;

    if (this.props.tv === true) {
      const parsed = queryString.parse(this.props.queryParams);

      if (parsed && !(parsed.arrivals === 'true' || parsed.departures === 'true')) {
        return (
          <h4 className="warning">Please add '?departures=true' or '?arrivals=true' to the URL</h4>
        );
      }

      fields = this.constructFields();
      flights = this.renderFlightsForTV(fields);
      className = "comp-flights-table tv";
      style = {
        backgroundColor: this.props.backgroundColor,
        color: this.props.textColor
      };
      ths = fields.map((field, index) => (
        <th key={`comp-flights-table-flight-${index}-${field.property}`}>{ field.name }</th>
      ));
      table = this.renderTableForTv(className, ths, flights, style);
      tableContainerStyle = {
        backgroundColor: this.props.backgroundColor
      };
      rendered = table;
    } else {
      fields = this.constructFields();
      flights = this.renderFlights(fields);
      className = "comp-flights-table not-tv";
      style = {
        backgroundColor: '#00b6c8',
        color: 'white'
      };
      ths = fields.map((field, index) => (
        <th key={`comp-flights-table-flight-${index}-${field.property}`}>{ field.name }</th>
      ));
      table = this.renderTable(className, ths, flights, style);
      tableContainerStyle = {
        backgroundColor: '#00b6c8'
      };

      const arrivalsText = {
        'Ro': 'Sosiri',
        'En': 'Arrivals'
      }[languageService.language] || '';

      const departuresText = {
        'Ro': 'Plecări',
        'En': 'Departures'
      }[languageService.language] || '';

      const displayText = {
        'Ro': 'Se afișează zborurile de pe',
        'En': 'Showing flights from'
      }[languageService.language] || '';

    const destinationsText = {
      'Ro': 'Alege o destinație',
      'En': 'Pick a destination'
    }[languageService.language] || 'Alege o destinație';

    let content = null;
    let displayTextContent = null;

    if (this.state.showDestinations) {
      content = (
        <Destinations />
      );
    } else {
      content = table;
      displayTextContent = (
        <div className="col-lg-12 u-fc-white u-m-b-15">
          {displayText} {this.state.flightsDate.format('DD/MM/YYYY')}
        </div>
      );
    }

      rendered = (
        <div className="comp-flights-table-container col-md-12" style={tableContainerStyle}>
					<div className="row">
	          <div className="col-lg-8 comp-flights-table-container__buttons">
		          <button className={`btn btn-info ${this.state.arrivals === 'true' ? 'btn-info-active-flights' : ''}`} onClick={this.showArrivals.bind(this)}>
                <img src="/assets/images/icon_arrivals.png" />
		            <span>{arrivalsText}</span>
		          </button>

		          <button className={`btn btn-info m-l-really-small ${this.state.departures === 'true' ? 'btn-info-active-flights' : ''}`} onClick={this.showDepartures.bind(this)}>
                <img src="/assets/images/icon_departures.png" />
		            <span>{departuresText}</span>
		          </button>

              <div className="comp-flights-table-container__datepicker m-l-really-small">
  					    <DatePicker selected={this.state.flightsDate} onChange={this.handleChange} customInput={<ExampleCustomInput />} dateFormat="DD/MM/YYYY" withPortal />
              </div>

              <div className="comp-flights-table-container__datepicker m-l-really-small">
                <button className="btn btn-info" onClick={this.showDestinations.bind(this)}>
                  {destinationsText} <i className="fa fa-globe" />
                </button>
              </div>
						</div>

            {displayTextContent}
          </div>

          {content}
        </div>
      );
    }

    return (
      <div className="row" id="flights-table">
        {rendered}
      </div>
    );
  }
}

FlightsTable.defaultProps = {
  textFont: 'Arial',
  textColor: 'white',
  textBackgroundColor: 'transparent',
  backgroundColor: '#2F3133',
  alertColor: 'white',
  alertBackgroundColor: '#c0392b',
  warningBackgroundColor: '#f1c40f'
};

export default FlightsTable;



// WEBPACK FOOTER //
// ./src/components/flightsTable/index.js